import React, { useEffect, useState } from 'react';
import { Button, Modal} from 'react-bootstrap';
import { useTranslate } from 'react-polyglot';

import 'react-toastify/dist/ReactToastify.css';
import Field from '../../Wizard/Field/Field';
import { useAuth } from '../../../../Auth';
import { useAxios } from '../../../../AxiosHandler';

import moment from "moment";

function CalendarEventEditorModal(props) {
    const auth = useAuth();
    const t = useTranslate();  
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [event, setEvent] = useState<any>(props.event);
    const [booking, setBooking] = useState();
    const [allPeople, setAllPeople] = useState<Array<any>>([]);

    const [specHours, setSpecHours] = useState(false);


    function fetchInfo() {
        axios.all([
            axios.single({
                method: "get",
                url: "/api/bookings/" + props.event.booking.bookingId,
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/persons",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
        ])
        .then(axios.spread((...res) => {
            setBooking(res[0].data);
            setAllPeople(res[1].data);
        }))
        .catch(err => console.log(err));
    }

    useEffect(() => {
        if (props.event != undefined) {
            setEvent({
                ...props.event,
                start: moment(props.event.start).add(-1, "hour").toDate().toString(),
                end: moment(props.event.end).add(-1, "hour").toDate().toString()
            });
            if (moment(props.event.start).hours() == moment(props.event.end).hours()) {
                setSpecHours(false);
            } else {
                setSpecHours(true);
            }
        }
        if (booking == undefined && props.event != undefined) {
            fetchInfo();
        }
    }, [props.event]);

    return (
        <Modal size="lg" show={props.show} onHide={() => {
            if(props.onHide != undefined) props.onHide();
            setBooking(undefined);
        }}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {
                        auth.user["userdata"]["orgRole"][0] != "cleaningstaff" ?
                            t("bookingcalendar.modal.editevent.title")
                        :
                            props.event?.name ?? ""
                    }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="bookingcalendarmodaleditevent">
                {props.showBookingInfo != undefined && props.showBookingInfo == true ?
                    auth.user["userdata"]["orgRole"][0] != "cleaningstaff" ?
                        <React.Fragment>
                            <h3>{t("bookingcalendar.modal.editevent.info.booking_title")}</h3>
                            <table>
                                <tbody>
                                    <tr>
                                        <th>{t("bookingcalendar.modal.editevent.info.organisation") + ": "}</th>
                                        <td>{(booking != undefined ? (booking as any).organization : "")}</td>
                                    </tr>
                                    <tr>
                                        <th>{t("bookingcalendar.modal.editevent.info.contactperson") + ": "}</th>
                                        <td>{(booking != undefined ? ((booking as any).lastname != null ? (booking as any).lastname : "") + ( (booking as any).lastname != null && (booking as any).firstname != null ? ", " : "") + ((booking as any).firstname != null ? (booking as any).firstname : "") : "")}</td>
                                    </tr>
                                    <tr>
                                        <th>{t("bookingcalendar.modal.editevent.info.phone") + ": "}</th>
                                        <td>{(booking != undefined ? (booking as any).phone : "")}</td>
                                    </tr>
                                    <tr>
                                        <th>{t("bookingcalendar.modal.editevent.info.email") + ": "}</th>
                                        <td>{(booking != undefined ? (booking as any).email : "")}</td>
                                    </tr>
                                    <tr>
                                        <th>{t("bookingcalendar.modal.editevent.info.description") + ": "}</th>
                                        <td>{(booking != undefined ? (booking as any).description : "")}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <hr/>
                        </React.Fragment>
                    : null
                : null}
                { props.showBookingInfo != undefined && props.showBookingInfo == true && allPeople.length > 0 && props.event != undefined && props.event.booking != undefined ?
                    auth.user["userdata"]["orgRole"][0] != "cleaningstaff" ? 
                        <React.Fragment>
                            <h3>{t("bookingcalendar.modal.editevent.info.booking_people_title")}</h3>
                            <table className="eventgueststable">
                                <thead>
                                    <tr>
                                        <th>{t("people.lastname")}</th>
                                        <th>{t("people.firstname")}</th>
                                        <th>{t("people.email")}</th>
                                        <th>{t("people.phone")}</th>
                                        <th>{t("people.organization")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.event.booking.people.map((pId, key) => {
                                        let person = allPeople.find(p => p._id == pId);
                                        if (person != undefined) {
                                            return <tr key={key}>
                                                <td>{person["lastname"]}</td>
                                                <td>{person["firstname"]}</td>
                                                <td>{person["email"]}</td>
                                                <td>{person["phone"]}</td>
                                                <td>{person["organization"]}</td>
                                            </tr>;
                                        } else {
                                            return <tr key={key}></tr>;
                                        }
                                    })}
                                </tbody>
                            </table>
                            <hr/>
                        </React.Fragment>
                    : null
                : null }
                {props.showBookingLink != undefined && props.showBookingLink == true ?
                    auth.user["userdata"]["orgRole"][0] != "janitor" && auth.user["userdata"]["orgRole"][0] != "cleaningstaff" ?
                        <React.Fragment>
                            {(booking != undefined ? (<a target="_blank" rel="noopener noreferrer" href={window.location.origin + "/booking/" + (booking as any)._id}>{window.location.origin + "/booking/" + (booking as any)._id}</a>) : "")}
                            <hr/>
                        </React.Fragment>
                    : null
                : null}
                { auth.user["userdata"]["orgRole"][0] != "janitor" && auth.user["userdata"]["orgRole"][0] != "cleaningstaff" ?
                    <Field
                        type="checkbox"
                        title={t("bookingcalendar.modal.editevent.specifyhours")}
                        onChange={(val) => { setSpecHours(val) }}
                        value={specHours}
                    ></Field>
                : null }
                <Field
                    type="dateselector"
                    title={t("bookingcalendar.modal.editevent.from")}
                    onChange={(date) => {
                        let tempEvent = event;
                        tempEvent.start = date;
                        setEvent(JSON.parse(JSON.stringify(tempEvent)));
                    }}
                    value={event != undefined && event.start != undefined && event.start != null ? new Date(event.start) : undefined}
                    dateFormat="dd.MM.yyyy"
                    startDate={event != undefined && event.start != undefined && event.start != null ? new Date(event.start) : undefined}
                    endDate={event != undefined && event.end != undefined && event.end != null ? new Date(event.end) : undefined}
                    selectsStart
                    showTimeSelect={specHours}
                    disabled={auth.user["userdata"]["orgRole"][0] == "janitor" || auth.user["userdata"]["orgRole"][0] == "cleaningstaff"}
                ></Field>
                <Field
                    type="dateselector"
                    title={t("bookingcalendar.modal.editevent.to")}
                    onChange={(date) => {
                        let tempEvent = event;
                        tempEvent.end = date;
                        setEvent(JSON.parse(JSON.stringify(tempEvent)));
                    }}
                    value={event != undefined && event.end != undefined && event.end != null ? new Date(event.end) : undefined}
                    dateFormat="dd.MM.yyyy"
                    startDate={event != undefined && event.start != undefined && event.start != null ? new Date(event.start) : undefined}
                    endDate={event != undefined && event.end != undefined && event.end != null ? new Date(event.end) : undefined}
                    selectsEnd
                    showTimeSelect={specHours}
                    disabled={auth.user["userdata"]["orgRole"][0] == "janitor" || auth.user["userdata"]["orgRole"][0] == "cleaningstaff"}
                ></Field>
                { auth.user["userdata"]["orgRole"][0] != "janitor" && auth.user["userdata"]["orgRole"][0] != "cleaningstaff" ?
                    <Button onClick={(evt) => {
                        if (props.onDelete != undefined) {
                            props.onDelete(event);
                        }
                    }}>{t("bookingcalendar.modal.editevent.delete")}</Button>
                : null }
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => { if(props.onCancel != undefined) props.onCancel(); }}>
                    {t("bookingcalendar.modal.editevent.cancel")}
                </Button>
                { auth.user["userdata"]["orgRole"][0] != "janitor" ?
                    <Button onClick={(evt) => {
                        if (props.onChange != undefined) {
                            props.onChange(event);
                        }
                    }}>
                        {props.confirmBtnText ?? t("bookingcalendar.modal.editevent.ok")}
                    </Button>
                : null }
            </Modal.Footer>
        </Modal>
    );
}
 
export default CalendarEventEditorModal; 